// AUTOGENERATED, DO NOT EDIT DIRECTLY. RUN generate_court_data.pl to update
export default [
   {
      "circuit" : "01",
      "citation" : "1stBapCir.",
      "code" : "01bap",
      "is_test" : false,
      "name" : "U.S. Bankruptcy Appellate Panel - First Circuit",
      "pcl_api_court_code" : "01bap",
      "region_code" : "01",
      "subdomain" : "ecf.ca1.uscourts.gov",
      "timezone" : "America/New_York",
      "type" : "appellate"
   },
   {
      "circuit" : "01",
      "citation" : "1stBapCir.TEST.",
      "code" : "01baptest",
      "is_test" : true,
      "name" : "U.S. Test Bankruptcy Appellate Panel - First Circuit",
      "pcl_api_court_code" : null,
      "region_code" : "01",
      "subdomain" : "ecf-test.ca1.uscourts.gov",
      "timezone" : "America/New_York",
      "type" : "appellate"
   },
   {
      "circuit" : "01",
      "citation" : "1stCir.",
      "code" : "01cae",
      "is_test" : false,
      "name" : "U.S. Court of Appeals - First Circuit",
      "pcl_api_court_code" : "01ca",
      "region_code" : "01",
      "subdomain" : "ecf.ca1.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "appellate"
   },
   {
      "circuit" : "01",
      "citation" : "1stCir.TEST.",
      "code" : "01caetest",
      "is_test" : true,
      "name" : "U.S. Court of Appeals - First Circuit (test)",
      "pcl_api_court_code" : null,
      "region_code" : "01",
      "subdomain" : "ecf-test.ca1.uscourts.gov",
      "timezone" : "America/New_York",
      "type" : "appellate"
   },
   {
      "circuit" : "02",
      "citation" : "2ndCir.",
      "code" : "02cae",
      "is_test" : false,
      "name" : "U.S. Court of Appeals - Second Circuit",
      "pcl_api_court_code" : "02ca",
      "region_code" : "02",
      "subdomain" : "ecf.ca2.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "appellate"
   },
   {
      "circuit" : "02",
      "citation" : "2ndCir.TEST.",
      "code" : "02caetest",
      "is_test" : true,
      "name" : "U.S. Court of Appeals - Second Circuit (test)",
      "pcl_api_court_code" : null,
      "region_code" : "02",
      "subdomain" : "ecf-test.ca2.uscourts.gov",
      "timezone" : "America/New_York",
      "type" : "appellate"
   },
   {
      "circuit" : "03",
      "citation" : "3rdCir.",
      "code" : "03cae",
      "is_test" : false,
      "name" : "U.S. Court of Appeals - Third Circuit",
      "pcl_api_court_code" : "03ca",
      "region_code" : "03",
      "subdomain" : "ecf.ca3.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "appellate"
   },
   {
      "circuit" : "03",
      "citation" : "3rdCir.TEST.",
      "code" : "03caetest",
      "is_test" : true,
      "name" : "U.S. Court of Appeals - Third Circuit (test)",
      "pcl_api_court_code" : null,
      "region_code" : "03",
      "subdomain" : "ecf-test.ca3.uscourts.gov",
      "timezone" : "America/New_York",
      "type" : "appellate"
   },
   {
      "circuit" : "03",
      "citation" : "3rdCir.TRAIN.",
      "code" : "03caetrain",
      "is_test" : true,
      "name" : "U.S. Court of Appeals - Third Circuit (train)",
      "pcl_api_court_code" : null,
      "region_code" : "03",
      "subdomain" : "ecf-train.ca3.uscourts.gov",
      "timezone" : "America/New_York",
      "type" : "appellate"
   },
   {
      "circuit" : "04",
      "citation" : "4thCir.",
      "code" : "04cae",
      "is_test" : false,
      "name" : "U.S. Court of Appeals - Fourth Circuit",
      "pcl_api_court_code" : "04ca",
      "region_code" : "04",
      "subdomain" : "ecf.ca4.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "appellate"
   },
   {
      "circuit" : "04",
      "citation" : "4thCir.TEST.",
      "code" : "04caetest",
      "is_test" : true,
      "name" : "U.S. Court of Appeals - Fourth Circuit (test)",
      "pcl_api_court_code" : null,
      "region_code" : "04",
      "subdomain" : "ecf-test.ca4.uscourts.gov",
      "timezone" : "America/New_York",
      "type" : "appellate"
   },
   {
      "circuit" : "05",
      "citation" : "5thCir.",
      "code" : "05cae",
      "is_test" : false,
      "name" : "U.S. Court of Appeals - Fifth Circuit",
      "pcl_api_court_code" : "05ca",
      "region_code" : "05",
      "subdomain" : "ecf.ca5.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "appellate"
   },
   {
      "circuit" : "05",
      "citation" : "5thCir.TEST.",
      "code" : "05caetest",
      "is_test" : true,
      "name" : "U.S. Court of Appeals - Fifth Circuit (test)",
      "pcl_api_court_code" : null,
      "region_code" : "05",
      "subdomain" : "ecf-test.ca5.uscourts.gov",
      "timezone" : "America/Chicago",
      "type" : "appellate"
   },
   {
      "circuit" : "06",
      "citation" : "6thCir.",
      "code" : "06cae",
      "is_test" : false,
      "name" : "U.S. Court of Appeals - Sixth Circuit",
      "pcl_api_court_code" : "06ca",
      "region_code" : "06",
      "subdomain" : "ecf.ca6.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "appellate"
   },
   {
      "circuit" : "06",
      "citation" : "6thCir.TEST.",
      "code" : "06caetest",
      "is_test" : true,
      "name" : "U.S. Court of Appeals - Sixth Circuit (test)",
      "pcl_api_court_code" : null,
      "region_code" : "06",
      "subdomain" : "ecf-test.ca6.uscourts.gov",
      "timezone" : "America/New_York",
      "type" : "appellate"
   },
   {
      "circuit" : "06",
      "citation" : "6thCir.TRAIN.",
      "code" : "06caetrain",
      "is_test" : true,
      "name" : "U.S. Court of Appeals - Sixth Circuit (train)",
      "pcl_api_court_code" : null,
      "region_code" : "06",
      "subdomain" : "ecf-train.ca6.uscourts.gov",
      "timezone" : "America/New_York",
      "type" : "appellate"
   },
   {
      "circuit" : "07",
      "citation" : "7thCir.",
      "code" : "07cae",
      "is_test" : false,
      "name" : "U.S. Court of Appeals - Seventh Circuit",
      "pcl_api_court_code" : "07ca",
      "region_code" : "07",
      "subdomain" : "ecf.ca7.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "appellate"
   },
   {
      "circuit" : "08",
      "citation" : "8thCir.",
      "code" : "08cae",
      "is_test" : false,
      "name" : "U.S. Court of Appeals - Eighth Circuit",
      "pcl_api_court_code" : "08ca",
      "region_code" : "08",
      "subdomain" : "ecf.ca8.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "appellate"
   },
   {
      "circuit" : "08",
      "citation" : "8thCir.TRAIN.",
      "code" : "08caetrain",
      "is_test" : true,
      "name" : "U.S. Court of Appeals - Eighth Circuit (train)",
      "pcl_api_court_code" : null,
      "region_code" : "08",
      "subdomain" : "ecf-train.ca8.uscourts.gov",
      "timezone" : "America/Chicago",
      "type" : "appellate"
   },
   {
      "circuit" : "09",
      "citation" : "9thBapCir.",
      "code" : "09bap",
      "is_test" : false,
      "name" : "U.S. Bankruptcy Appellate Panel - Ninth Circuit",
      "pcl_api_court_code" : "09bap",
      "region_code" : "09",
      "subdomain" : "ecf.ca9.uscourts.gov",
      "timezone" : "America/Los_Angeles",
      "type" : "appellate"
   },
   {
      "circuit" : "09",
      "citation" : "9thBapCir.TEST.",
      "code" : "09baptest",
      "is_test" : true,
      "name" : "U.S. Test Bankruptcy Appellate Panel - Ninth Circuit",
      "pcl_api_court_code" : null,
      "region_code" : "09",
      "subdomain" : "ecf-test.ca9.uscourts.gov",
      "timezone" : "America/Los_Angeles",
      "type" : "appellate"
   },
   {
      "circuit" : "09",
      "citation" : "9thBapCir.TRAIN.",
      "code" : "09baptrain",
      "is_test" : true,
      "name" : "U.S. Train Bankruptcy Appellate Panel - Ninth Circuit",
      "pcl_api_court_code" : null,
      "region_code" : "09",
      "subdomain" : "ecf-train.ca9.uscourts.gov",
      "timezone" : "America/Los_Angeles",
      "type" : "appellate"
   },
   {
      "circuit" : "09",
      "citation" : "9thCir.",
      "code" : "09cae",
      "is_test" : false,
      "name" : "U.S. Court of Appeals - Ninth Circuit",
      "pcl_api_court_code" : "09ca",
      "region_code" : "09",
      "subdomain" : "ecf.ca9.uscourts.gov",
      "timezone" : "US/Pacific",
      "type" : "appellate"
   },
   {
      "circuit" : "09",
      "citation" : "9thCir.TEST.",
      "code" : "09caetest",
      "is_test" : true,
      "name" : "U.S. Court of Appeals - Ninth Circuit (test)",
      "pcl_api_court_code" : null,
      "region_code" : "09",
      "subdomain" : "ecf-test.ca9.uscourts.gov",
      "timezone" : "America/Los_Angeles",
      "type" : "appellate"
   },
   {
      "circuit" : "09",
      "citation" : "9thCir.TRAIN.",
      "code" : "09caetrain",
      "is_test" : true,
      "name" : "U.S. Court of Appeals - Ninth Circuit (train)",
      "pcl_api_court_code" : null,
      "region_code" : "09",
      "subdomain" : "ecf-train.ca9.uscourts.gov",
      "timezone" : "America/Los_Angeles",
      "type" : "appellate"
   },
   {
      "circuit" : "10",
      "citation" : "10thBapCir.",
      "code" : "10bap",
      "is_test" : false,
      "name" : "U.S. Bankruptcy Appellate Panel - Tenth Circuit",
      "pcl_api_court_code" : "10bap",
      "region_code" : "10",
      "subdomain" : "ecf.ca10.uscourts.gov",
      "timezone" : "America/Denver",
      "type" : "appellate"
   },
   {
      "circuit" : "10",
      "citation" : "10thBapCir.TEST.",
      "code" : "10baptest",
      "is_test" : true,
      "name" : "U.S. TEST Bankruptcy Appellate Panel - Tenth Circuit",
      "pcl_api_court_code" : null,
      "region_code" : "10",
      "subdomain" : "ecf-test.ca10.uscourts.gov",
      "timezone" : "America/Denver",
      "type" : "appellate"
   },
   {
      "circuit" : "10",
      "citation" : "10thBapCir.TRAIN.",
      "code" : "10baptrain",
      "is_test" : true,
      "name" : "U.S. Train Bankruptcy Appellate Panel - Tenth Circuit",
      "pcl_api_court_code" : null,
      "region_code" : "10",
      "subdomain" : "ecf-train.ca10.uscourts.gov",
      "timezone" : "America/Denver",
      "type" : "appellate"
   },
   {
      "circuit" : "10",
      "citation" : "10thCir.",
      "code" : "10cae",
      "is_test" : false,
      "name" : "U.S. Court of Appeals - Tenth Circuit",
      "pcl_api_court_code" : "10ca",
      "region_code" : "10",
      "subdomain" : "ecf.ca10.uscourts.gov",
      "timezone" : "US/Mountain",
      "type" : "appellate"
   },
   {
      "circuit" : "10",
      "citation" : "10thCir.TEST.",
      "code" : "10caetest",
      "is_test" : true,
      "name" : "U.S. Court of Appeals - Tenth Circuit (test)",
      "pcl_api_court_code" : null,
      "region_code" : "10",
      "subdomain" : "ecf-test.ca10.uscourts.gov",
      "timezone" : "America/Denver",
      "type" : "appellate"
   },
   {
      "circuit" : "10",
      "citation" : "10thCir.TRAIN.",
      "code" : "10caetrain",
      "is_test" : true,
      "name" : "U.S. Court of Appeals - Tenth Circuit (train)",
      "pcl_api_court_code" : null,
      "region_code" : "10",
      "subdomain" : "ecf-train.ca10.uscourts.gov",
      "timezone" : "America/Denver",
      "type" : "appellate"
   },
   {
      "circuit" : "11",
      "citation" : "11thCir.",
      "code" : "11cae",
      "is_test" : false,
      "name" : "U.S. Court of Appeals - Eleventh Circuit",
      "pcl_api_court_code" : "11ca",
      "region_code" : "11",
      "subdomain" : "ecf.ca11.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "appellate"
   },
   {
      "circuit" : null,
      "citation" : "FedCir.",
      "code" : "cafc",
      "is_test" : false,
      "name" : "U.S. Court of Appeals - Federal Circuit",
      "pcl_api_court_code" : "cafc",
      "region_code" : "cafc",
      "subdomain" : "ecf.cafc.uscourts.gov",
      "timezone" : "America/New_York",
      "type" : "appellate"
   },
   {
      "circuit" : "dc",
      "citation" : "D.C.Cir.",
      "code" : "dccae",
      "is_test" : false,
      "name" : "U.S. Court of Appeals - District of Columbia Circuit",
      "pcl_api_court_code" : "dcca",
      "region_code" : "dc",
      "subdomain" : "ecf.cadc.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "appellate"
   },
   {
      "circuit" : "09",
      "citation" : "Bankr.D.Alaska",
      "code" : "akbke",
      "is_test" : false,
      "name" : "Alaska Bankruptcy Court",
      "pcl_api_court_code" : "akbk",
      "region_code" : "ak",
      "subdomain" : "ecf.akb.uscourts.gov",
      "timezone" : "US/Alaska",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "09",
      "citation" : "Bankr.D.Alaska.TEST.",
      "code" : "akbtest",
      "is_test" : true,
      "name" : "Alaska TEST Bankruptcy Court",
      "pcl_api_court_code" : null,
      "region_code" : "ak",
      "subdomain" : "ecf-test.akb.uscourts.gov",
      "timezone" : "America/Anchorage",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "09",
      "citation" : "Bankr.D.Alaska.TRAIN.",
      "code" : "akbtrain",
      "is_test" : true,
      "name" : "Alaska TRAIN Bankruptcy Court",
      "pcl_api_court_code" : null,
      "region_code" : "ak",
      "subdomain" : "ecf-train.akb.uscourts.gov",
      "timezone" : "America/Anchorage",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "11",
      "citation" : "Bankr.M.D.Ala.",
      "code" : "almbke",
      "is_test" : false,
      "name" : "Alabama Middle Bankruptcy Court",
      "pcl_api_court_code" : "almbk",
      "region_code" : "alm",
      "subdomain" : "ecf.almb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "11",
      "citation" : "Bankr.N.D.Ala.",
      "code" : "alnbke",
      "is_test" : false,
      "name" : "Alabama Northern Bankruptcy Court",
      "pcl_api_court_code" : "alnbk",
      "region_code" : "aln",
      "subdomain" : "ecf.alnb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : null,
      "citation" : "Bankr.N.D.Ala.TEST.",
      "code" : "alnbtest",
      "is_test" : true,
      "name" : "Alabama Northern TEST Bankruptcy Court",
      "pcl_api_court_code" : null,
      "region_code" : "aln",
      "subdomain" : "ecf-test.alnb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : null,
      "citation" : "Bankr.N.D.Ala.TRAIN.",
      "code" : "alnbtrain",
      "is_test" : true,
      "name" : "Alabama Northern TRAIN Bankruptcy Court",
      "pcl_api_court_code" : null,
      "region_code" : "aln",
      "subdomain" : "ecf-train.alnb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "11",
      "citation" : "Bankr.S.D.Ala.",
      "code" : "alsbke",
      "is_test" : false,
      "name" : "Alabama Southern Bankruptcy Court",
      "pcl_api_court_code" : "alsbk",
      "region_code" : "als",
      "subdomain" : "ecf.alsb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "08",
      "citation" : "Bankr.E.D.Ark.",
      "code" : "arebke",
      "is_test" : false,
      "name" : "Arkansas Eastern Bankruptcy Court",
      "pcl_api_court_code" : "arebk",
      "region_code" : "are",
      "subdomain" : "ecf.areb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "08",
      "citation" : "Bankr.W.D.Ark.",
      "code" : "arwbke",
      "is_test" : false,
      "name" : "Arkansas Western Bankruptcy Court",
      "pcl_api_court_code" : "arwbk",
      "region_code" : "arw",
      "subdomain" : "ecf.arwb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "09",
      "citation" : "Bankr.D.Ariz.",
      "code" : "azbke",
      "is_test" : false,
      "name" : "Arizona Bankruptcy Court",
      "pcl_api_court_code" : "azbk",
      "region_code" : "az",
      "subdomain" : "ecf.azb.uscourts.gov",
      "timezone" : "US/Arizona",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "09",
      "citation" : "Bankr.D.Ariz.TEST",
      "code" : "azbtest",
      "is_test" : true,
      "name" : "Arizona TEST Bankruptcy Court",
      "pcl_api_court_code" : null,
      "region_code" : "az",
      "subdomain" : "ecf-test.azb.uscourts.gov",
      "timezone" : "US/Arizona",
      "type" : "bankruptcy"
   },
   {
      "circuit" : null,
      "citation" : "Bankr.D.Ariz.TRAIN",
      "code" : "azbtrain",
      "is_test" : true,
      "name" : "Arizona TRAIN Bankruptcy Court",
      "pcl_api_court_code" : null,
      "region_code" : "az",
      "subdomain" : "ecf-train.azb.uscourts.gov",
      "timezone" : "US/Mountain",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "09",
      "citation" : "Bankr.C.D.Cal.",
      "code" : "cacbke",
      "is_test" : false,
      "name" : "California Central Bankruptcy Court",
      "pcl_api_court_code" : "cacbk",
      "region_code" : "cac",
      "subdomain" : "ecf.cacb.uscourts.gov",
      "timezone" : "US/Pacific",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "09",
      "citation" : "Bankr.E.D.Cal.",
      "code" : "caebke",
      "is_test" : false,
      "name" : "California Eastern Bankruptcy Court",
      "pcl_api_court_code" : "caebk",
      "region_code" : "cae",
      "subdomain" : "ecf.caeb.uscourts.gov",
      "timezone" : "US/Pacific",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "09",
      "citation" : "Bankr.N.D.Cal.",
      "code" : "canbke",
      "is_test" : false,
      "name" : "California Northern Bankruptcy Court",
      "pcl_api_court_code" : "canbk",
      "region_code" : "can",
      "subdomain" : "ecf.canb.uscourts.gov",
      "timezone" : "US/Pacific",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "09",
      "citation" : "Bankr.S.D.Cal.",
      "code" : "casbke",
      "is_test" : false,
      "name" : "California Southern Bankruptcy Court",
      "pcl_api_court_code" : "casbk",
      "region_code" : "cas",
      "subdomain" : "ecf.casb.uscourts.gov",
      "timezone" : "US/Pacific",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "09",
      "citation" : "Bankr.S.D.Cal.TEST.",
      "code" : "casbtest",
      "is_test" : true,
      "name" : "California Southern TEST Bankruptcy Court",
      "pcl_api_court_code" : null,
      "region_code" : "cas",
      "subdomain" : "ecf-test.casb.uscourts.gov",
      "timezone" : "America/Los_Angeles",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "09",
      "citation" : "Bankr.S.D.Cal.TRAIN.",
      "code" : "casbtrain",
      "is_test" : true,
      "name" : "California Southern TRAIN Bankruptcy Court",
      "pcl_api_court_code" : null,
      "region_code" : "cas",
      "subdomain" : "ecf-train.casb.uscourts.gov",
      "timezone" : "America/Los_Angeles",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "10",
      "citation" : "Bankr.D.Colo.",
      "code" : "cobke",
      "is_test" : false,
      "name" : "Colorado Bankruptcy Court",
      "pcl_api_court_code" : "cobk",
      "region_code" : "co",
      "subdomain" : "ecf.cob.uscourts.gov",
      "timezone" : "US/Mountain",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "02",
      "citation" : "Bankr.D.Conn.",
      "code" : "ctbke",
      "is_test" : false,
      "name" : "Connecticut Bankruptcy Court",
      "pcl_api_court_code" : "ctbk",
      "region_code" : "ct",
      "subdomain" : "ecf.ctb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "dc",
      "citation" : "Bankr.D.D.C.",
      "code" : "dcbke",
      "is_test" : false,
      "name" : "District Of Columbia Bankruptcy Court",
      "pcl_api_court_code" : "dcbk",
      "region_code" : "dc",
      "subdomain" : "ecf.dcb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "03",
      "citation" : "Bankr.D.Del.",
      "code" : "debke",
      "is_test" : false,
      "name" : "Delaware Bankruptcy Court",
      "pcl_api_court_code" : "debk",
      "region_code" : "de",
      "subdomain" : "ecf.deb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "11",
      "citation" : "Bankr.M.D.Fla.",
      "code" : "flmbke",
      "is_test" : false,
      "name" : "Florida Middle Bankruptcy Court",
      "pcl_api_court_code" : "flmbk",
      "region_code" : "flm",
      "subdomain" : "ecf.flmb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "11",
      "citation" : "Bankr.N.D.Fla.",
      "code" : "flnbke",
      "is_test" : false,
      "name" : "Florida Northern Bankruptcy Court",
      "pcl_api_court_code" : "flnbk",
      "region_code" : "fln",
      "subdomain" : "ecf.flnb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "11",
      "citation" : "Bankr.S.D.Fla.",
      "code" : "flsbke",
      "is_test" : false,
      "name" : "Florida Southern Bankruptcy Court",
      "pcl_api_court_code" : "flsbk",
      "region_code" : "fls",
      "subdomain" : "ecf.flsb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : null,
      "citation" : "Bankr.S.D.Fla.TEST.",
      "code" : "flsbtest",
      "is_test" : true,
      "name" : "Florida Southern TEST Bankruptcy Court",
      "pcl_api_court_code" : null,
      "region_code" : "fls",
      "subdomain" : "ecf-test.flsb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "11",
      "citation" : "Bankr.M.D.Ga.",
      "code" : "gambke",
      "is_test" : false,
      "name" : "Georgia Middle Bankruptcy Court",
      "pcl_api_court_code" : "gambk",
      "region_code" : "gam",
      "subdomain" : "ecf.gamb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "11",
      "citation" : "Bankr.N.D.Ga.",
      "code" : "ganbke",
      "is_test" : false,
      "name" : "Georgia Northern Bankruptcy Court",
      "pcl_api_court_code" : "ganbk",
      "region_code" : "gan",
      "subdomain" : "ecf.ganb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "11",
      "citation" : "Bankr.N.D.Ga.TEST",
      "code" : "ganbtrain",
      "is_test" : true,
      "name" : "Georgia Northern TEST Bankruptcy Court",
      "pcl_api_court_code" : null,
      "region_code" : "gan",
      "subdomain" : "ecf-train.ganb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "11",
      "citation" : "Bankr.S.D.Ga.",
      "code" : "gasbke",
      "is_test" : false,
      "name" : "Georgia Southern Bankruptcy Court",
      "pcl_api_court_code" : "gasbk",
      "region_code" : "gas",
      "subdomain" : "ecf.gasb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "09",
      "citation" : "Bankr.D.Guam",
      "code" : "gubke",
      "is_test" : false,
      "name" : "Guam Bankruptcy Court",
      "pcl_api_court_code" : "gubk",
      "region_code" : "gu",
      "subdomain" : "ecf.gub.uscourts.gov",
      "timezone" : "Pacific/Guam",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "09",
      "citation" : "Bankr.D.Hawaii",
      "code" : "hibke",
      "is_test" : false,
      "name" : "Hawaii Bankruptcy Court",
      "pcl_api_court_code" : "hibk",
      "region_code" : "hi",
      "subdomain" : "ecf.hib.uscourts.gov",
      "timezone" : "US/Hawaii",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "08",
      "citation" : "Bankr.N.D.Iowa",
      "code" : "ianbke",
      "is_test" : false,
      "name" : "Iowa Northern Bankruptcy Court",
      "pcl_api_court_code" : "ianbk",
      "region_code" : "ian",
      "subdomain" : "ecf.ianb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "08",
      "citation" : "Bankr.S.D.Iowa",
      "code" : "iasbke",
      "is_test" : false,
      "name" : "Iowa Southern Bankruptcy Court",
      "pcl_api_court_code" : "iasbk",
      "region_code" : "ias",
      "subdomain" : "ecf.iasb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "09",
      "citation" : "Bankr.D.Idaho",
      "code" : "idbke",
      "is_test" : false,
      "name" : "Idaho Bankruptcy Court",
      "pcl_api_court_code" : "idbk",
      "region_code" : "id",
      "subdomain" : "ecf.idb.uscourts.gov",
      "timezone" : "US/Mountain",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "07",
      "citation" : "Bankr.C.D.Ill.",
      "code" : "ilcbke",
      "is_test" : false,
      "name" : "Illinois Central Bankruptcy Court",
      "pcl_api_court_code" : "ilcbk",
      "region_code" : "ilc",
      "subdomain" : "ecf.ilcb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "07",
      "citation" : "Bankr.N.D.Ill.",
      "code" : "ilnbke",
      "is_test" : false,
      "name" : "Illinois Northern Bankruptcy Court",
      "pcl_api_court_code" : "ilnbk",
      "region_code" : "iln",
      "subdomain" : "ecf.ilnb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "07",
      "citation" : "Bankr.S.D.Ill.",
      "code" : "ilsbke",
      "is_test" : false,
      "name" : "Illinois Southern Bankruptcy Court",
      "pcl_api_court_code" : "ilsbk",
      "region_code" : "ils",
      "subdomain" : "ecf.ilsb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "07",
      "citation" : "Bankr.N.D.Ind.",
      "code" : "innbke",
      "is_test" : false,
      "name" : "Indiana Northern Bankruptcy Court",
      "pcl_api_court_code" : "innbk",
      "region_code" : "inn",
      "subdomain" : "ecf.innb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "07",
      "citation" : "Bankr.S.D.Ind.",
      "code" : "insbke",
      "is_test" : false,
      "name" : "Indiana Southern Bankruptcy Court",
      "pcl_api_court_code" : "insbk",
      "region_code" : "ins",
      "subdomain" : "ecf.insb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "10",
      "citation" : "Bankr.D.Kan.",
      "code" : "ksbke",
      "is_test" : false,
      "name" : "Kansas Bankruptcy Court",
      "pcl_api_court_code" : "ksbk",
      "region_code" : "ks",
      "subdomain" : "ecf.ksb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "06",
      "citation" : "Bankr.E.D.Ky.",
      "code" : "kyebke",
      "is_test" : false,
      "name" : "Kentucky Eastern Bankruptcy Court",
      "pcl_api_court_code" : "kyebk",
      "region_code" : "kye",
      "subdomain" : "ecf.kyeb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "06",
      "citation" : "Bankr.W.D.Ky.",
      "code" : "kywbke",
      "is_test" : false,
      "name" : "Kentucky Western Bankruptcy Court",
      "pcl_api_court_code" : "kywbk",
      "region_code" : "kyw",
      "subdomain" : "ecf.kywb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "05",
      "citation" : "Bankr.E.D.La.",
      "code" : "laebke",
      "is_test" : false,
      "name" : "Louisiana Eastern Bankruptcy Court",
      "pcl_api_court_code" : "laebk",
      "region_code" : "lae",
      "subdomain" : "ecf.laeb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "05",
      "citation" : "Bankr.M.D.La.",
      "code" : "lambke",
      "is_test" : false,
      "name" : "Louisiana Middle Bankruptcy Court",
      "pcl_api_court_code" : "lambk",
      "region_code" : "lam",
      "subdomain" : "ecf.lamb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "05",
      "citation" : "Bankr.W.D.La.",
      "code" : "lawbke",
      "is_test" : false,
      "name" : "Louisiana Western Bankruptcy Court",
      "pcl_api_court_code" : "lawbk",
      "region_code" : "law",
      "subdomain" : "ecf.lawb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "01",
      "citation" : "Bankr.D.Mass.",
      "code" : "mabke",
      "is_test" : false,
      "name" : "Massachusetts Bankruptcy Court",
      "pcl_api_court_code" : "mabk",
      "region_code" : "ma",
      "subdomain" : "ecf.mab.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "04",
      "citation" : "Bankr.D.Md.",
      "code" : "mdbke",
      "is_test" : false,
      "name" : "Maryland Bankruptcy Court",
      "pcl_api_court_code" : "mdbk",
      "region_code" : "md",
      "subdomain" : "ecf.mdb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "01",
      "citation" : "Bankr.D.Me.",
      "code" : "mebke",
      "is_test" : false,
      "name" : "Maine Bankruptcy Court",
      "pcl_api_court_code" : "mebk",
      "region_code" : "me",
      "subdomain" : "ecf.meb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "06",
      "citation" : "Bankr.E.D.Mich.",
      "code" : "miebke",
      "is_test" : false,
      "name" : "Michigan Eastern Bankruptcy Court",
      "pcl_api_court_code" : "miebk",
      "region_code" : "mie",
      "subdomain" : "ecf.mieb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "06",
      "citation" : "Bankr.W.D.Mich.",
      "code" : "miwbke",
      "is_test" : false,
      "name" : "Michigan Western Bankruptcy Court",
      "pcl_api_court_code" : "miwbk",
      "region_code" : "miw",
      "subdomain" : "ecf.miwb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "08",
      "citation" : "Bankr.D.Minn.",
      "code" : "mnbke",
      "is_test" : false,
      "name" : "Minnesota Bankruptcy Court",
      "pcl_api_court_code" : "mnbk",
      "region_code" : "mn",
      "subdomain" : "ecf.mnb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "08",
      "citation" : "Bankr.E.D.Mo.",
      "code" : "moebke",
      "is_test" : false,
      "name" : "Missouri Eastern Bankruptcy Court",
      "pcl_api_court_code" : "moebk",
      "region_code" : "moe",
      "subdomain" : "ecf.moeb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "08",
      "citation" : "Bankr.W.D.Mo.",
      "code" : "mowbke",
      "is_test" : false,
      "name" : "Missouri Western Bankruptcy Court",
      "pcl_api_court_code" : "mowbk",
      "region_code" : "mow",
      "subdomain" : "ecf.mowb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "05",
      "citation" : "Bankr.N.D.Miss",
      "code" : "msnbke",
      "is_test" : false,
      "name" : "Mississippi Northern Bankruptcy Court",
      "pcl_api_court_code" : "msnbk",
      "region_code" : "msn",
      "subdomain" : "ecf.msnb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "05",
      "citation" : "Bankr.S.D.Miss.",
      "code" : "mssbke",
      "is_test" : false,
      "name" : "Mississippi Southern Bankruptcy Court",
      "pcl_api_court_code" : "mssbk",
      "region_code" : "mss",
      "subdomain" : "ecf.mssb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "09",
      "citation" : "Bankr.D.Mont.",
      "code" : "mtbke",
      "is_test" : false,
      "name" : "Montana Bankruptcy Court",
      "pcl_api_court_code" : "mtbk",
      "region_code" : "mt",
      "subdomain" : "ecf.mtb.uscourts.gov",
      "timezone" : "US/Mountain",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "04",
      "citation" : "Bankr.E.D.N.C.",
      "code" : "ncebke",
      "is_test" : false,
      "name" : "North Carolina Eastern Bankruptcy Court",
      "pcl_api_court_code" : "ncebk",
      "region_code" : "nce",
      "subdomain" : "ecf.nceb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "04",
      "citation" : "Bankr.M.D.N.C.",
      "code" : "ncmbke",
      "is_test" : false,
      "name" : "North Carolina Middle Bankruptcy Court",
      "pcl_api_court_code" : "ncmbk",
      "region_code" : "ncm",
      "subdomain" : "ecf.ncmb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "04",
      "citation" : "Bankr.W.D.N.C.",
      "code" : "ncwbke",
      "is_test" : false,
      "name" : "North Carolina Western Bankruptcy Court",
      "pcl_api_court_code" : "ncwbk",
      "region_code" : "ncw",
      "subdomain" : "ecf.ncwb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "08",
      "citation" : "Bankr.D.N.D.",
      "code" : "ndbke",
      "is_test" : false,
      "name" : "North Dakota Bankruptcy Court",
      "pcl_api_court_code" : "ndbk",
      "region_code" : "nd",
      "subdomain" : "ecf.ndb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "08",
      "citation" : "Bankr.D.Neb.",
      "code" : "nebke",
      "is_test" : false,
      "name" : "Nebraska Bankruptcy Court",
      "pcl_api_court_code" : "nebk",
      "region_code" : "ne",
      "subdomain" : "ecf.neb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "01",
      "citation" : "Bankr.D.N.H.",
      "code" : "nhbke",
      "is_test" : false,
      "name" : "New Hampshire Bankruptcy Court",
      "pcl_api_court_code" : "nhbk",
      "region_code" : "nh",
      "subdomain" : "ecf.nhb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "03",
      "citation" : "Bankr.D.N.J.",
      "code" : "njbke",
      "is_test" : false,
      "name" : "New Jersey Bankruptcy Court",
      "pcl_api_court_code" : "njbk",
      "region_code" : "nj",
      "subdomain" : "ecf.njb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "03",
      "citation" : "Bankr.D.N.J.TEST.",
      "code" : "njbtest",
      "is_test" : true,
      "name" : "New Jersey TEST Bankruptcy Court",
      "pcl_api_court_code" : null,
      "region_code" : "nj",
      "subdomain" : "ecf-test.njb.uscourts.gov",
      "timezone" : "America/New_York",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "03",
      "citation" : "Bankr.D.N.J.TRAIN.",
      "code" : "njbtrain",
      "is_test" : true,
      "name" : "New Jersey TRAIN Bankruptcy Court",
      "pcl_api_court_code" : null,
      "region_code" : "nj",
      "subdomain" : "ecf-train.njb.uscourts.gov",
      "timezone" : "America/New_York",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "10",
      "citation" : "Bankr.D.N.M.",
      "code" : "nmbke",
      "is_test" : false,
      "name" : "New Mexico Bankruptcy Court",
      "pcl_api_court_code" : "nmbk",
      "region_code" : "nm",
      "subdomain" : "ecf.nmb.uscourts.gov",
      "timezone" : "US/Mountain",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "09",
      "citation" : "Bankr.N.M.ISS.",
      "code" : "nmibke",
      "is_test" : false,
      "name" : "Northern Mariana Islands Bankruptcy Court",
      "pcl_api_court_code" : "nmibk",
      "region_code" : "nmi",
      "subdomain" : "ecf.nmib.uscourts.gov",
      "timezone" : "Pacific/Guam",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "09",
      "citation" : "Bankr.D.Nev.",
      "code" : "nvbke",
      "is_test" : false,
      "name" : "Nevada Bankruptcy Court",
      "pcl_api_court_code" : "nvbk",
      "region_code" : "nv",
      "subdomain" : "ecf.nvb.uscourts.gov",
      "timezone" : "US/Pacific",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "02",
      "citation" : "Bankr.E.D.N.Y.",
      "code" : "nyebke",
      "is_test" : false,
      "name" : "New York Eastern Bankruptcy Court",
      "pcl_api_court_code" : "nyebk",
      "region_code" : "nye",
      "subdomain" : "ecf.nyeb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "02",
      "citation" : "Bankr.N.D.N.Y.",
      "code" : "nynbke",
      "is_test" : false,
      "name" : "New York Northern Bankruptcy Court",
      "pcl_api_court_code" : "nynbk",
      "region_code" : "nyn",
      "subdomain" : "ecf.nynb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "02",
      "citation" : "Bankr.S.D.N.Y.",
      "code" : "nysbke",
      "is_test" : false,
      "name" : "New York Southern Bankruptcy Court",
      "pcl_api_court_code" : "nysbk",
      "region_code" : "nys",
      "subdomain" : "ecf.nysb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : null,
      "citation" : "Bankr.S.D.N.Y.TEST.",
      "code" : "nysbtest",
      "is_test" : true,
      "name" : "New York Southern TEST Bankruptcy Court",
      "pcl_api_court_code" : null,
      "region_code" : "nys",
      "subdomain" : "ecf-test.nysb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : null,
      "citation" : "Bankr.S.D.N.Y.TRAIN.",
      "code" : "nysbtrain",
      "is_test" : true,
      "name" : "New York Southern TRAIN Bankruptcy Court",
      "pcl_api_court_code" : null,
      "region_code" : "nys",
      "subdomain" : "ecf-train.nysb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "02",
      "citation" : "Bankr.W.D.N.Y.",
      "code" : "nywbke",
      "is_test" : false,
      "name" : "New York Western Bankruptcy Court",
      "pcl_api_court_code" : "nywbk",
      "region_code" : "nyw",
      "subdomain" : "ecf.nywb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "06",
      "citation" : "Bankr.N.D.Ohio",
      "code" : "ohnbke",
      "is_test" : false,
      "name" : "Ohio Northern Bankruptcy Court",
      "pcl_api_court_code" : "ohnbk",
      "region_code" : "ohn",
      "subdomain" : "ecf.ohnb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "06",
      "citation" : "Bankr.S.D.Ohio",
      "code" : "ohsbke",
      "is_test" : false,
      "name" : "Ohio Southern Bankruptcy Court",
      "pcl_api_court_code" : "ohsbk",
      "region_code" : "ohs",
      "subdomain" : "ecf.ohsb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "10",
      "citation" : "Bankr.E.D.Okla.",
      "code" : "okebke",
      "is_test" : false,
      "name" : "Oklahoma Eastern Bankruptcy Court",
      "pcl_api_court_code" : "okebk",
      "region_code" : "oke",
      "subdomain" : "ecf.okeb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "10",
      "citation" : "Bankr.N.D.Okla.",
      "code" : "oknbke",
      "is_test" : false,
      "name" : "Oklahoma Northern Bankruptcy Court",
      "pcl_api_court_code" : "oknbk",
      "region_code" : "okn",
      "subdomain" : "ecf.oknb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "10",
      "citation" : "Bankr.W.D.Okla.",
      "code" : "okwbke",
      "is_test" : false,
      "name" : "Oklahoma Western Bankruptcy Court",
      "pcl_api_court_code" : "okwbk",
      "region_code" : "okw",
      "subdomain" : "ecf.okwb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "09",
      "citation" : "Bankr.D.Or.",
      "code" : "orbke",
      "is_test" : false,
      "name" : "Oregon Bankruptcy Court",
      "pcl_api_court_code" : "orbk",
      "region_code" : "or",
      "subdomain" : "ecf.orb.uscourts.gov",
      "timezone" : "US/Pacific",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "09",
      "citation" : "Bankr.D.Or.TEST.",
      "code" : "orbtest",
      "is_test" : true,
      "name" : "Oregon TEST Bankruptcy Court",
      "pcl_api_court_code" : null,
      "region_code" : "or",
      "subdomain" : "ecf-test.orb.uscourts.gov",
      "timezone" : "America/Los_Angeles",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "09",
      "citation" : "Bankr.D.Or.TRAIN.",
      "code" : "orbtrain",
      "is_test" : true,
      "name" : "Oregon TRAIN Bankruptcy Court",
      "pcl_api_court_code" : null,
      "region_code" : "or",
      "subdomain" : "ecf-train.orb.uscourts.gov",
      "timezone" : "America/Los_Angeles",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "03",
      "citation" : "Bankr.E.D.Pa.",
      "code" : "paebke",
      "is_test" : false,
      "name" : "Pennsylvania Eastern Bankruptcy Court",
      "pcl_api_court_code" : "paebk",
      "region_code" : "pae",
      "subdomain" : "ecf.paeb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "03",
      "citation" : "Bankr.M.D.Pa.",
      "code" : "pambke",
      "is_test" : false,
      "name" : "Pennsylvania Middle Bankruptcy Court",
      "pcl_api_court_code" : "pambk",
      "region_code" : "pam",
      "subdomain" : "ecf.pamb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "03",
      "citation" : "Bankr.W.D.Pa.",
      "code" : "pawbke",
      "is_test" : false,
      "name" : "Pennsylvania Western Bankruptcy Court",
      "pcl_api_court_code" : "pawbk",
      "region_code" : "paw",
      "subdomain" : "ecf.pawb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "01",
      "citation" : "Bankr.D.P.R.",
      "code" : "prbke",
      "is_test" : false,
      "name" : "Puerto Rico Bankruptcy Court",
      "pcl_api_court_code" : "prbk",
      "region_code" : "pr",
      "subdomain" : "ecf.prb.uscourts.gov",
      "timezone" : "America/Puerto_Rico",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "01",
      "citation" : "Bankr.D.R.I.",
      "code" : "ribke",
      "is_test" : false,
      "name" : "Rhode Island Bankruptcy Court",
      "pcl_api_court_code" : "ribk",
      "region_code" : "ri",
      "subdomain" : "ecf.rib.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "04",
      "citation" : "Bankr.D.S.C.",
      "code" : "scbke",
      "is_test" : false,
      "name" : "South Carolina Bankruptcy Court",
      "pcl_api_court_code" : "scbk",
      "region_code" : "sc",
      "subdomain" : "ecf.scb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : null,
      "citation" : "Bankr.D.S.C.TEST.",
      "code" : "scbtest",
      "is_test" : true,
      "name" : "South Carolina TEST Bankruptcy Court",
      "pcl_api_court_code" : null,
      "region_code" : "sc",
      "subdomain" : "ecf-test.scb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "08",
      "citation" : "Bankr.D.S.D.",
      "code" : "sdbke",
      "is_test" : false,
      "name" : "South Dakota Bankruptcy Court",
      "pcl_api_court_code" : "sdbk",
      "region_code" : "sd",
      "subdomain" : "ecf.sdb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "06",
      "citation" : "Bankr.E.D.Tenn.",
      "code" : "tnebke",
      "is_test" : false,
      "name" : "Tennessee Eastern Bankruptcy Court",
      "pcl_api_court_code" : "tnebk",
      "region_code" : "tne",
      "subdomain" : "ecf.tneb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "06",
      "citation" : "Bankr.M.D.Tenn.",
      "code" : "tnmbke",
      "is_test" : false,
      "name" : "Tennessee Middle Bankruptcy Court",
      "pcl_api_court_code" : "tnmbk",
      "region_code" : "tnm",
      "subdomain" : "ecf.tnmb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "06",
      "citation" : "Bankr.W.D.Tenn.",
      "code" : "tnwbke",
      "is_test" : false,
      "name" : "Tennessee Western Bankruptcy Court",
      "pcl_api_court_code" : "tnwbk",
      "region_code" : "tnw",
      "subdomain" : "ecf.tnwb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "05",
      "citation" : "Bankr.E.D.Tex.",
      "code" : "txebke",
      "is_test" : false,
      "name" : "Texas Eastern Bankruptcy Court",
      "pcl_api_court_code" : "txebk",
      "region_code" : "txe",
      "subdomain" : "ecf.txeb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "05",
      "citation" : "Bankr.N.D.Tex.",
      "code" : "txnbke",
      "is_test" : false,
      "name" : "Texas Northern Bankruptcy Court",
      "pcl_api_court_code" : "txnbk",
      "region_code" : "txn",
      "subdomain" : "ecf.txnb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "05",
      "citation" : "Bankr.S.D.Tex.",
      "code" : "txsbke",
      "is_test" : false,
      "name" : "Texas Southern Bankruptcy Court",
      "pcl_api_court_code" : "txsbk",
      "region_code" : "txs",
      "subdomain" : "ecf.txsb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "05",
      "citation" : "Bankr.W.D.Tex.",
      "code" : "txwbke",
      "is_test" : false,
      "name" : "Texas Western Bankruptcy Court",
      "pcl_api_court_code" : "txwbk",
      "region_code" : "txw",
      "subdomain" : "ecf.txwb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "10",
      "citation" : "Bankr.D.Utah",
      "code" : "utbke",
      "is_test" : false,
      "name" : "Utah Bankruptcy Court",
      "pcl_api_court_code" : "utbk",
      "region_code" : "ut",
      "subdomain" : "ecf.utb.uscourts.gov",
      "timezone" : "US/Mountain",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "04",
      "citation" : "Bankr.E.D.Va.",
      "code" : "vaebke",
      "is_test" : false,
      "name" : "Virginia Eastern Bankruptcy Court",
      "pcl_api_court_code" : "vaebk",
      "region_code" : "vae",
      "subdomain" : "ecf.vaeb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "04",
      "citation" : "Bankr.W.D.Va.",
      "code" : "vawbke",
      "is_test" : false,
      "name" : "Virginia Western Bankruptcy Court",
      "pcl_api_court_code" : "vawbk",
      "region_code" : "vaw",
      "subdomain" : "ecf.vawb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "03",
      "citation" : "Bankr.D.VirginIslands",
      "code" : "vibke",
      "is_test" : false,
      "name" : "Virgin Islands Bankruptcy Court",
      "pcl_api_court_code" : "vibk",
      "region_code" : "vi",
      "subdomain" : "ecf.vib.uscourts.gov",
      "timezone" : "America/Virgin",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "02",
      "citation" : "Bankr.D.Vt.",
      "code" : "vtbke",
      "is_test" : false,
      "name" : "Vermont Bankruptcy Court",
      "pcl_api_court_code" : "vtbk",
      "region_code" : "vt",
      "subdomain" : "ecf.vtb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "09",
      "citation" : "Bankr.E.D.Wash.",
      "code" : "waebke",
      "is_test" : false,
      "name" : "Washington Eastern Bankruptcy Court",
      "pcl_api_court_code" : "waebk",
      "region_code" : "wae",
      "subdomain" : "ecf.waeb.uscourts.gov",
      "timezone" : "US/Pacific",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "09",
      "citation" : "Bankr.W.D.Wash.",
      "code" : "wawbke",
      "is_test" : false,
      "name" : "Washington Western Bankruptcy Court",
      "pcl_api_court_code" : "wawbk",
      "region_code" : "waw",
      "subdomain" : "ecf.wawb.uscourts.gov",
      "timezone" : "US/Pacific",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "07",
      "citation" : "Bankr.E.D.Wis.",
      "code" : "wiebke",
      "is_test" : false,
      "name" : "Wisconsin Eastern Bankruptcy Court",
      "pcl_api_court_code" : "wiebk",
      "region_code" : "wie",
      "subdomain" : "ecf.wieb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "07",
      "citation" : "Bankr.E.D.Wis.TEST",
      "code" : "wiebtest",
      "is_test" : true,
      "name" : "Wisconsin Eastern TEST Bankruptcy Court",
      "pcl_api_court_code" : null,
      "region_code" : "wie",
      "subdomain" : "ecf-test.wieb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "07",
      "citation" : "Bankr.W.D.Wis",
      "code" : "wiwbke",
      "is_test" : false,
      "name" : "Wisconsin Western Bankruptcy Court",
      "pcl_api_court_code" : "wiwbk",
      "region_code" : "wiw",
      "subdomain" : "ecf.wiwb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "04",
      "citation" : "Bankr.N.D.W.Va.",
      "code" : "wvnbke",
      "is_test" : false,
      "name" : "West Virginia Northern Bankruptcy Court",
      "pcl_api_court_code" : "wvnbk",
      "region_code" : "wvn",
      "subdomain" : "ecf.wvnb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "04",
      "citation" : "Bankr.S.D.W.Va.",
      "code" : "wvsbke",
      "is_test" : false,
      "name" : "West Virginia Southern Bankruptcy Court",
      "pcl_api_court_code" : "wvsbk",
      "region_code" : "wvs",
      "subdomain" : "ecf.wvsb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "10",
      "citation" : "Bankr.D.Wyo.",
      "code" : "wybke",
      "is_test" : false,
      "name" : "Wyoming Bankruptcy Court",
      "pcl_api_court_code" : "wybk",
      "region_code" : "wy",
      "subdomain" : "ecf.wyb.uscourts.gov",
      "timezone" : "US/Mountain",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "09",
      "citation" : "Dist.Alaska.",
      "code" : "akdce",
      "is_test" : false,
      "name" : "Alaska District Court",
      "pcl_api_court_code" : "akdc",
      "region_code" : "ak",
      "subdomain" : "ecf.akd.uscourts.gov",
      "timezone" : "US/Alaska",
      "type" : "district"
   },
   {
      "circuit" : "11",
      "citation" : "Dist.M.D.Ala.",
      "code" : "almdce",
      "is_test" : false,
      "name" : "Alabama Middle District Court",
      "pcl_api_court_code" : "almdc",
      "region_code" : "alm",
      "subdomain" : "ecf.almd.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "district"
   },
   {
      "circuit" : "11",
      "citation" : "Dist.N.D.Ala.",
      "code" : "alndce",
      "is_test" : false,
      "name" : "Alabama Northern District Court",
      "pcl_api_court_code" : "alndc",
      "region_code" : "aln",
      "subdomain" : "ecf.alnd.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "district"
   },
   {
      "circuit" : "11",
      "citation" : "Dist.S.D.Ala.",
      "code" : "alsdce",
      "is_test" : false,
      "name" : "Alabama Southern District Court",
      "pcl_api_court_code" : "alsdc",
      "region_code" : "als",
      "subdomain" : "ecf.alsd.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "district"
   },
   {
      "circuit" : "08",
      "citation" : "Dist.E.D.Ark.",
      "code" : "aredce",
      "is_test" : false,
      "name" : "Arkansas Eastern District Court",
      "pcl_api_court_code" : "aredc",
      "region_code" : "are",
      "subdomain" : "ecf.ared.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "district"
   },
   {
      "circuit" : "08",
      "citation" : "Dist.W.D.Ark.",
      "code" : "arwdce",
      "is_test" : false,
      "name" : "Arkansas Western District Court",
      "pcl_api_court_code" : "arwdc",
      "region_code" : "arw",
      "subdomain" : "ecf.arwd.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "district"
   },
   {
      "circuit" : "09",
      "citation" : "Dist.Ariz.",
      "code" : "azdce",
      "is_test" : false,
      "name" : "Arizona District Court",
      "pcl_api_court_code" : "azdc",
      "region_code" : "az",
      "subdomain" : "ecf.azd.uscourts.gov",
      "timezone" : "US/Arizona",
      "type" : "district"
   },
   {
      "circuit" : "09",
      "citation" : "Dist.C.D.Cal.",
      "code" : "cacdce",
      "is_test" : false,
      "name" : "California Central District Court",
      "pcl_api_court_code" : "cacdc",
      "region_code" : "cac",
      "subdomain" : "ecf.cacd.uscourts.gov",
      "timezone" : "US/Pacific",
      "type" : "district"
   },
   {
      "circuit" : "09",
      "citation" : "Dist.E.D.Cal.",
      "code" : "caedce",
      "is_test" : false,
      "name" : "California Eastern District Court",
      "pcl_api_court_code" : "caedc",
      "region_code" : "cae",
      "subdomain" : "ecf.caed.uscourts.gov",
      "timezone" : "US/Pacific",
      "type" : "district"
   },
   {
      "circuit" : "09",
      "citation" : "Dist.N.D.Cal.",
      "code" : "candce",
      "is_test" : false,
      "name" : "California Northern District Court",
      "pcl_api_court_code" : "candc",
      "region_code" : "can",
      "subdomain" : "ecf.cand.uscourts.gov",
      "timezone" : "US/Pacific",
      "type" : "district"
   },
   {
      "circuit" : "09",
      "citation" : "Dist.N.D.Cal.TEST.",
      "code" : "candtest",
      "is_test" : true,
      "name" : "California Northern TEST District Court",
      "pcl_api_court_code" : null,
      "region_code" : "can",
      "subdomain" : "ecf-test.cand.uscourts.gov",
      "timezone" : "US/Pacific",
      "type" : "district"
   },
   {
      "circuit" : "09",
      "citation" : "Dist.S.D.Cal.",
      "code" : "casdce",
      "is_test" : false,
      "name" : "California Southern District Court",
      "pcl_api_court_code" : "casdc",
      "region_code" : "cas",
      "subdomain" : "ecf.casd.uscourts.gov",
      "timezone" : "US/Pacific",
      "type" : "district"
   },
   {
      "circuit" : "10",
      "citation" : "Dist.Colo.",
      "code" : "codce",
      "is_test" : false,
      "name" : "Colorado District Court",
      "pcl_api_court_code" : "codc",
      "region_code" : "co",
      "subdomain" : "ecf.cod.uscourts.gov",
      "timezone" : "US/Mountain",
      "type" : "district"
   },
   {
      "circuit" : "02",
      "citation" : "Dist.Conn.",
      "code" : "ctdce",
      "is_test" : false,
      "name" : "Connecticut District Court",
      "pcl_api_court_code" : "ctdc",
      "region_code" : "ct",
      "subdomain" : "ecf.ctd.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "dc",
      "citation" : "Dist.D.C.",
      "code" : "dcdce",
      "is_test" : false,
      "name" : "District Of Columbia District Court",
      "pcl_api_court_code" : "dcdc",
      "region_code" : "dc",
      "subdomain" : "ecf.dcd.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "dc",
      "citation" : "Dist.TEST",
      "code" : "dctest",
      "is_test" : true,
      "name" : "District TEST Court",
      "pcl_api_court_code" : null,
      "region_code" : "dc",
      "subdomain" : "dcecf.psc.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "03",
      "citation" : "Dist.Del.",
      "code" : "dedce",
      "is_test" : false,
      "name" : "Delaware District Court",
      "pcl_api_court_code" : "dedc",
      "region_code" : "de",
      "subdomain" : "ecf.ded.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "11",
      "citation" : "Dist.M.D.Fla.",
      "code" : "flmdce",
      "is_test" : false,
      "name" : "Florida Middle District Court",
      "pcl_api_court_code" : "flmdc",
      "region_code" : "flm",
      "subdomain" : "ecf.flmd.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "11",
      "citation" : "Dist.N.D.Fla.",
      "code" : "flndce",
      "is_test" : false,
      "name" : "Florida Northern District Court",
      "pcl_api_court_code" : "flndc",
      "region_code" : "fln",
      "subdomain" : "ecf.flnd.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "11",
      "citation" : "Dist.N.D.Fla.TEST.",
      "code" : "flndtest",
      "is_test" : true,
      "name" : "Florida Northern TEST District Court",
      "pcl_api_court_code" : null,
      "region_code" : "fln",
      "subdomain" : "ecf-test.flnd.uscourts.gov",
      "timezone" : "America/New_York",
      "type" : "district"
   },
   {
      "circuit" : "11",
      "citation" : "Dist.S.D.Fla.",
      "code" : "flsdce",
      "is_test" : false,
      "name" : "Florida Southern District Court",
      "pcl_api_court_code" : "flsdc",
      "region_code" : "fls",
      "subdomain" : "ecf.flsd.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "11",
      "citation" : "Dist.M.D.Ga.",
      "code" : "gamdce",
      "is_test" : false,
      "name" : "Georgia Middle District Court",
      "pcl_api_court_code" : "gamdc",
      "region_code" : "gam",
      "subdomain" : "ecf.gamd.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "11",
      "citation" : "Dist.N.D.Ga.",
      "code" : "gandce",
      "is_test" : false,
      "name" : "Georgia Northern District Court",
      "pcl_api_court_code" : "gandc",
      "region_code" : "gan",
      "subdomain" : "ecf.gand.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "11",
      "citation" : "Dist.S.D.Ga.",
      "code" : "gasdce",
      "is_test" : false,
      "name" : "Georgia Southern District Court",
      "pcl_api_court_code" : "gasdc",
      "region_code" : "gas",
      "subdomain" : "ecf.gasd.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "09",
      "citation" : "Dist.Guam",
      "code" : "gudce",
      "is_test" : false,
      "name" : "Guam District Court",
      "pcl_api_court_code" : "gudc",
      "region_code" : "gu",
      "subdomain" : "ecf.gud.uscourts.gov",
      "timezone" : "Pacific/Guam",
      "type" : "district"
   },
   {
      "circuit" : "09",
      "citation" : "Dist.Hawaii",
      "code" : "hidce",
      "is_test" : false,
      "name" : "Hawaii District Court",
      "pcl_api_court_code" : "hidc",
      "region_code" : "hi",
      "subdomain" : "ecf.hid.uscourts.gov",
      "timezone" : "US/Hawaii",
      "type" : "district"
   },
   {
      "circuit" : "08",
      "citation" : "Dist.N.D.Iowa",
      "code" : "iandce",
      "is_test" : false,
      "name" : "Iowa Northern District Court",
      "pcl_api_court_code" : "iandc",
      "region_code" : "ian",
      "subdomain" : "ecf.iand.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "district"
   },
   {
      "circuit" : "08",
      "citation" : "Dist.S.D.Iowa",
      "code" : "iasdce",
      "is_test" : false,
      "name" : "Iowa Southern District Court",
      "pcl_api_court_code" : "iasdc",
      "region_code" : "ias",
      "subdomain" : "ecf.iasd.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "district"
   },
   {
      "circuit" : "09",
      "citation" : "Dist.Idaho",
      "code" : "iddce",
      "is_test" : false,
      "name" : "Idaho District Court",
      "pcl_api_court_code" : "iddc",
      "region_code" : "id",
      "subdomain" : "ecf.idd.uscourts.gov",
      "timezone" : "US/Mountain",
      "type" : "district"
   },
   {
      "circuit" : "07",
      "citation" : "Dist.C.D.Ill.",
      "code" : "ilcdce",
      "is_test" : false,
      "name" : "Illinois Central District Court",
      "pcl_api_court_code" : "ilcdc",
      "region_code" : "ilc",
      "subdomain" : "ecf.ilcd.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "district"
   },
   {
      "circuit" : "07",
      "citation" : "Dist.N.D.Ill.",
      "code" : "ilndce",
      "is_test" : false,
      "name" : "Illinois Northern District Court",
      "pcl_api_court_code" : "ilndc",
      "region_code" : "iln",
      "subdomain" : "ecf.ilnd.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "district"
   },
   {
      "circuit" : "07",
      "citation" : "Dist.S.D.Ill.",
      "code" : "ilsdce",
      "is_test" : false,
      "name" : "Illinois Southern District Court",
      "pcl_api_court_code" : "ilsdc",
      "region_code" : "ils",
      "subdomain" : "ecf.ilsd.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "district"
   },
   {
      "circuit" : "07",
      "citation" : "Dist.N.D.Ind.",
      "code" : "inndce",
      "is_test" : false,
      "name" : "Indiana Northern District Court",
      "pcl_api_court_code" : "inndc",
      "region_code" : "inn",
      "subdomain" : "ecf.innd.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "07",
      "citation" : "Dist.S.D.Ind.",
      "code" : "insdce",
      "is_test" : false,
      "name" : "Indiana Southern District Court",
      "pcl_api_court_code" : "insdc",
      "region_code" : "ins",
      "subdomain" : "ecf.insd.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "10",
      "citation" : "Dist.Kan.",
      "code" : "ksdce",
      "is_test" : false,
      "name" : "Kansas District Court",
      "pcl_api_court_code" : "ksdc",
      "region_code" : "ks",
      "subdomain" : "ecf.ksd.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "district"
   },
   {
      "circuit" : "10",
      "citation" : "Dist.D.Kan.TEST.",
      "code" : "ksdtest",
      "is_test" : true,
      "name" : "Kansas TEST District Court",
      "pcl_api_court_code" : null,
      "region_code" : "ks",
      "subdomain" : "ecf-test.ksd.uscourts.gov",
      "timezone" : "America/Chicago",
      "type" : "district"
   },
   {
      "circuit" : "06",
      "citation" : "Dist.E.D.Ky.",
      "code" : "kyedce",
      "is_test" : false,
      "name" : "Kentucky Eastern District Court",
      "pcl_api_court_code" : "kyedc",
      "region_code" : "kye",
      "subdomain" : "ecf.kyed.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "06",
      "citation" : "Dist.W.D.Ky.",
      "code" : "kywdce",
      "is_test" : false,
      "name" : "Kentucky Western District Court",
      "pcl_api_court_code" : "kywdc",
      "region_code" : "kyw",
      "subdomain" : "ecf.kywd.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "district"
   },
   {
      "circuit" : "05",
      "citation" : "Dist.E.D.La.",
      "code" : "laedce",
      "is_test" : false,
      "name" : "Louisiana Eastern District Court",
      "pcl_api_court_code" : "laedc",
      "region_code" : "lae",
      "subdomain" : "ecf.laed.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "district"
   },
   {
      "circuit" : "05",
      "citation" : "Dist.M.D.La.",
      "code" : "lamdce",
      "is_test" : false,
      "name" : "Louisiana Middle District Court",
      "pcl_api_court_code" : "lamdc",
      "region_code" : "lam",
      "subdomain" : "ecf.lamd.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "district"
   },
   {
      "circuit" : "05",
      "citation" : "Dist.W.D.La.",
      "code" : "lawdce",
      "is_test" : false,
      "name" : "Louisiana Western District Court",
      "pcl_api_court_code" : "lawdc",
      "region_code" : "law",
      "subdomain" : "ecf.lawd.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "district"
   },
   {
      "circuit" : "01",
      "citation" : "Dist.Mass.",
      "code" : "madce",
      "is_test" : false,
      "name" : "Massachusetts District Court",
      "pcl_api_court_code" : "madc",
      "region_code" : "ma",
      "subdomain" : "ecf.mad.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "04",
      "citation" : "Dist.Md.",
      "code" : "mddce",
      "is_test" : false,
      "name" : "Maryland District Court",
      "pcl_api_court_code" : "mddc",
      "region_code" : "md",
      "subdomain" : "ecf.mdd.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "01",
      "citation" : "Dist.Me.",
      "code" : "medce",
      "is_test" : false,
      "name" : "Maine District Court",
      "pcl_api_court_code" : "medc",
      "region_code" : "me",
      "subdomain" : "ecf.med.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "06",
      "citation" : "Dist.E.D.Mich.",
      "code" : "miedce",
      "is_test" : false,
      "name" : "Michigan Eastern District Court",
      "pcl_api_court_code" : "miedc",
      "region_code" : "mie",
      "subdomain" : "ecf.mied.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "06",
      "citation" : "Dist.W.D.Mich.",
      "code" : "miwdce",
      "is_test" : false,
      "name" : "Michigan Western District Court",
      "pcl_api_court_code" : "miwdc",
      "region_code" : "miw",
      "subdomain" : "ecf.miwd.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "08",
      "citation" : "Dist.Minn.",
      "code" : "mndce",
      "is_test" : false,
      "name" : "Minnesota District Court",
      "pcl_api_court_code" : "mndc",
      "region_code" : "mn",
      "subdomain" : "ecf.mnd.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "district"
   },
   {
      "circuit" : "08",
      "citation" : "Dist.Minn.TEST.",
      "code" : "mndtest",
      "is_test" : true,
      "name" : "Minnesota TEST District Court",
      "pcl_api_court_code" : null,
      "region_code" : "mn",
      "subdomain" : "ecf-test.mnd.uscourts.gov",
      "timezone" : "America/Chicago",
      "type" : "district"
   },
   {
      "circuit" : "08",
      "citation" : "Dist.Minn.TRAIN.",
      "code" : "mndtrain",
      "is_test" : true,
      "name" : "Minnesota TRAIN District Court",
      "pcl_api_court_code" : null,
      "region_code" : "mn",
      "subdomain" : "ecf-train.mnd.uscourts.gov",
      "timezone" : "America/Chicago",
      "type" : "district"
   },
   {
      "circuit" : "08",
      "citation" : "Dist.E.D.Mo.",
      "code" : "moedce",
      "is_test" : false,
      "name" : "Missouri Eastern District Court",
      "pcl_api_court_code" : "moedc",
      "region_code" : "moe",
      "subdomain" : "ecf.moed.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "district"
   },
   {
      "circuit" : "08",
      "citation" : "Dist.W.D.Mo.",
      "code" : "mowdce",
      "is_test" : false,
      "name" : "Missouri Western District Court",
      "pcl_api_court_code" : "mowdc",
      "region_code" : "mow",
      "subdomain" : "ecf.mowd.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "district"
   },
   {
      "circuit" : "05",
      "citation" : "Dist.N.D.Miss",
      "code" : "msndce",
      "is_test" : false,
      "name" : "Mississippi Northern District Court",
      "pcl_api_court_code" : "msndc",
      "region_code" : "msn",
      "subdomain" : "ecf.msnd.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "district"
   },
   {
      "circuit" : "05",
      "citation" : "Dist.S.D.Miss.",
      "code" : "mssdce",
      "is_test" : false,
      "name" : "Mississippi Southern District Court",
      "pcl_api_court_code" : "mssdc",
      "region_code" : "mss",
      "subdomain" : "ecf.mssd.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "district"
   },
   {
      "circuit" : "09",
      "citation" : "Dist.Mont.",
      "code" : "mtdce",
      "is_test" : false,
      "name" : "Montana District Court",
      "pcl_api_court_code" : "mtdc",
      "region_code" : "mt",
      "subdomain" : "ecf.mtd.uscourts.gov",
      "timezone" : "US/Mountain",
      "type" : "district"
   },
   {
      "circuit" : "04",
      "citation" : "Dist.E.D.N.C.",
      "code" : "ncedce",
      "is_test" : false,
      "name" : "North Carolina Eastern District Court",
      "pcl_api_court_code" : "ncedc",
      "region_code" : "nce",
      "subdomain" : "ecf.nced.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "04",
      "citation" : "Dist.M.D.N.C.",
      "code" : "ncmdce",
      "is_test" : false,
      "name" : "North Carolina Middle District Court",
      "pcl_api_court_code" : "ncmdc",
      "region_code" : "ncm",
      "subdomain" : "ecf.ncmd.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "04",
      "citation" : "Dist.W.D.N.C.",
      "code" : "ncwdce",
      "is_test" : false,
      "name" : "North Carolina Western District Court",
      "pcl_api_court_code" : "ncwdc",
      "region_code" : "ncw",
      "subdomain" : "ecf.ncwd.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "08",
      "citation" : "Dist.N.D.",
      "code" : "nddce",
      "is_test" : false,
      "name" : "North Dakota District Court",
      "pcl_api_court_code" : "nddc",
      "region_code" : "nd",
      "subdomain" : "ecf.ndd.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "district"
   },
   {
      "circuit" : "08",
      "citation" : "Dist.Neb.",
      "code" : "nedce",
      "is_test" : false,
      "name" : "Nebraska District Court",
      "pcl_api_court_code" : "nedc",
      "region_code" : "ne",
      "subdomain" : "ecf.ned.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "district"
   },
   {
      "circuit" : "01",
      "citation" : "Dist.N.H.",
      "code" : "nhdce",
      "is_test" : false,
      "name" : "New Hampshire District Court",
      "pcl_api_court_code" : "nhdc",
      "region_code" : "nh",
      "subdomain" : "ecf.nhd.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "03",
      "citation" : "Dist.N.J.",
      "code" : "njdce",
      "is_test" : false,
      "name" : "New Jersey District Court",
      "pcl_api_court_code" : "njdc",
      "region_code" : "nj",
      "subdomain" : "ecf.njd.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "10",
      "citation" : "Dist.N.M.",
      "code" : "nmdce",
      "is_test" : false,
      "name" : "New Mexico District Court",
      "pcl_api_court_code" : "nmdc",
      "region_code" : "nm",
      "subdomain" : "ecf.nmd.uscourts.gov",
      "timezone" : "US/Mountain",
      "type" : "district"
   },
   {
      "circuit" : "09",
      "citation" : "Dist.N.M.ISS.",
      "code" : "nmidce",
      "is_test" : false,
      "name" : "Northern Mariana Islands District Court",
      "pcl_api_court_code" : "nmidc",
      "region_code" : "nmi",
      "subdomain" : "ecf.nmid.uscourts.gov",
      "timezone" : "Pacific/Guam",
      "type" : "district"
   },
   {
      "circuit" : "09",
      "citation" : "Dist.Nev.",
      "code" : "nvdce",
      "is_test" : false,
      "name" : "Nevada District Court",
      "pcl_api_court_code" : "nvdc",
      "region_code" : "nv",
      "subdomain" : "ecf.nvd.uscourts.gov",
      "timezone" : "US/Pacific",
      "type" : "district"
   },
   {
      "circuit" : "09",
      "citation" : "Dist.Nev.TEST.",
      "code" : "nvdtest",
      "is_test" : true,
      "name" : "Nevada District TEST Court",
      "pcl_api_court_code" : null,
      "region_code" : "nv",
      "subdomain" : "ecf-test.nvd.uscourts.gov",
      "timezone" : "US/Pacific",
      "type" : "district"
   },
   {
      "circuit" : "02",
      "citation" : "Dist.E.D.N.Y.",
      "code" : "nyedce",
      "is_test" : false,
      "name" : "New York Eastern District Court",
      "pcl_api_court_code" : "nyedc",
      "region_code" : "nye",
      "subdomain" : "ecf.nyed.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "02",
      "citation" : "Dist.N.D.N.Y.",
      "code" : "nyndce",
      "is_test" : false,
      "name" : "New York Northern District Court",
      "pcl_api_court_code" : "nyndc",
      "region_code" : "nyn",
      "subdomain" : "ecf.nynd.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "02",
      "citation" : "Dist.S.D.N.Y.",
      "code" : "nysdce",
      "is_test" : false,
      "name" : "New York Southern District Court",
      "pcl_api_court_code" : "nysdc",
      "region_code" : "nys",
      "subdomain" : "ecf.nysd.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "02",
      "citation" : "Dist.W.D.N.Y.",
      "code" : "nywdce",
      "is_test" : false,
      "name" : "New York Western District Court",
      "pcl_api_court_code" : "nywdc",
      "region_code" : "nyw",
      "subdomain" : "ecf.nywd.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "06",
      "citation" : "Dist.N.D.Ohio",
      "code" : "ohndce",
      "is_test" : false,
      "name" : "Ohio Northern District Court",
      "pcl_api_court_code" : "ohndc",
      "region_code" : "ohn",
      "subdomain" : "ecf.ohnd.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "06",
      "citation" : "Dist.N.D.Ohio",
      "code" : "ohndea",
      "is_test" : false,
      "name" : "Ohio Northern District Court(asbestos)",
      "pcl_api_court_code" : "ohnde",
      "region_code" : "ohn",
      "subdomain" : "ecf-asbestos.ohnd.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "06",
      "citation" : "Dist.S.D.Ohio",
      "code" : "ohsdce",
      "is_test" : false,
      "name" : "Ohio Southern District Court",
      "pcl_api_court_code" : "ohsdc",
      "region_code" : "ohs",
      "subdomain" : "ecf.ohsd.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "10",
      "citation" : "Dist.E.D.Okla.",
      "code" : "okedce",
      "is_test" : false,
      "name" : "Oklahoma Eastern District Court",
      "pcl_api_court_code" : "okedc",
      "region_code" : "oke",
      "subdomain" : "ecf.oked.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "district"
   },
   {
      "circuit" : "10",
      "citation" : "Dist.N.D.Okla.",
      "code" : "okndce",
      "is_test" : false,
      "name" : "Oklahoma Northern District Court",
      "pcl_api_court_code" : "okndc",
      "region_code" : "okn",
      "subdomain" : "ecf.oknd.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "district"
   },
   {
      "circuit" : "10",
      "citation" : "Dist.W.D.Okla.",
      "code" : "okwdce",
      "is_test" : false,
      "name" : "Oklahoma Western District Court",
      "pcl_api_court_code" : "okwdc",
      "region_code" : "okw",
      "subdomain" : "ecf.okwd.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "district"
   },
   {
      "circuit" : "09",
      "citation" : "Dist.Or.",
      "code" : "ordce",
      "is_test" : false,
      "name" : "Oregon District Court",
      "pcl_api_court_code" : "ordc",
      "region_code" : "or",
      "subdomain" : "ecf.ord.uscourts.gov",
      "timezone" : "US/Pacific",
      "type" : "district"
   },
   {
      "circuit" : "03",
      "citation" : "Dist.E.D.Pa.",
      "code" : "paedce",
      "is_test" : false,
      "name" : "Pennsylvania Eastern District Court",
      "pcl_api_court_code" : "paedc",
      "region_code" : "pae",
      "subdomain" : "ecf.paed.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "03",
      "citation" : "Dist.M.D.Pa.",
      "code" : "pamdce",
      "is_test" : false,
      "name" : "Pennsylvania Middle District Court",
      "pcl_api_court_code" : "pamdc",
      "region_code" : "pam",
      "subdomain" : "ecf.pamd.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "03",
      "citation" : "Dist.W.D.Pa.",
      "code" : "pawdce",
      "is_test" : false,
      "name" : "Pennsylvania Western District Court",
      "pcl_api_court_code" : "pawdc",
      "region_code" : "paw",
      "subdomain" : "ecf.pawd.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "01",
      "citation" : "Dist.P.R.",
      "code" : "prdce",
      "is_test" : false,
      "name" : "Puerto Rico District Court",
      "pcl_api_court_code" : "prdc",
      "region_code" : "pr",
      "subdomain" : "ecf.prd.uscourts.gov",
      "timezone" : "America/Puerto_Rico",
      "type" : "district"
   },
   {
      "circuit" : "01",
      "citation" : "Dist.R.I.",
      "code" : "ridce",
      "is_test" : false,
      "name" : "Rhode Island District Court",
      "pcl_api_court_code" : "ridc",
      "region_code" : "ri",
      "subdomain" : "ecf.rid.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "04",
      "citation" : "Dist.S.C.",
      "code" : "scdce",
      "is_test" : false,
      "name" : "South Carolina District Court",
      "pcl_api_court_code" : "scdc",
      "region_code" : "sc",
      "subdomain" : "ecf.scd.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "08",
      "citation" : "Dist.S.D.",
      "code" : "sddce",
      "is_test" : false,
      "name" : "South Dakota District Court",
      "pcl_api_court_code" : "sddc",
      "region_code" : "sd",
      "subdomain" : "ecf.sdd.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "district"
   },
   {
      "circuit" : "06",
      "citation" : "Dist.E.D.Tenn.",
      "code" : "tnedce",
      "is_test" : false,
      "name" : "Tennessee Eastern District Court",
      "pcl_api_court_code" : "tnedc",
      "region_code" : "tne",
      "subdomain" : "ecf.tned.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "06",
      "citation" : "Dist.M.D.Tenn.",
      "code" : "tnmdce",
      "is_test" : false,
      "name" : "Tennessee Middle District Court",
      "pcl_api_court_code" : "tnmdc",
      "region_code" : "tnm",
      "subdomain" : "ecf.tnmd.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "district"
   },
   {
      "circuit" : "06",
      "citation" : "Dist.W.D.Tenn.",
      "code" : "tnwdce",
      "is_test" : false,
      "name" : "Tennessee Western District Court",
      "pcl_api_court_code" : "tnwdc",
      "region_code" : "tnw",
      "subdomain" : "ecf.tnwd.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "district"
   },
   {
      "circuit" : "05",
      "citation" : "Dist.E.D.Tex.",
      "code" : "txedce",
      "is_test" : false,
      "name" : "Texas Eastern District Court",
      "pcl_api_court_code" : "txedc",
      "region_code" : "txe",
      "subdomain" : "ecf.txed.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "district"
   },
   {
      "circuit" : "05",
      "citation" : "Dist.N.D.Tex.",
      "code" : "txndce",
      "is_test" : false,
      "name" : "Texas Northern District Court",
      "pcl_api_court_code" : "txndc",
      "region_code" : "txn",
      "subdomain" : "ecf.txnd.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "district"
   },
   {
      "circuit" : "05",
      "citation" : "Dist.S.D.Tex.",
      "code" : "txsdce",
      "is_test" : false,
      "name" : "Texas Southern District Court",
      "pcl_api_court_code" : "txsdc",
      "region_code" : "txs",
      "subdomain" : "ecf.txsd.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "district"
   },
   {
      "circuit" : "05",
      "citation" : "Dist.W.D.Tex.",
      "code" : "txwdce",
      "is_test" : false,
      "name" : "Texas Western District Court",
      "pcl_api_court_code" : "txwdc",
      "region_code" : "txw",
      "subdomain" : "ecf.txwd.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "district"
   },
   {
      "circuit" : "10",
      "citation" : "Dist.Utah",
      "code" : "utdce",
      "is_test" : false,
      "name" : "Utah District Court",
      "pcl_api_court_code" : "utdc",
      "region_code" : "ut",
      "subdomain" : "ecf.utd.uscourts.gov",
      "timezone" : "US/Mountain",
      "type" : "district"
   },
   {
      "circuit" : "04",
      "citation" : "Dist.E.D.Va.",
      "code" : "vaedce",
      "is_test" : false,
      "name" : "Virginia Eastern District Court",
      "pcl_api_court_code" : "vaedc",
      "region_code" : "vae",
      "subdomain" : "ecf.vaed.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "04",
      "citation" : "Dist.W.D.Va.",
      "code" : "vawdce",
      "is_test" : false,
      "name" : "Virginia Western District Court",
      "pcl_api_court_code" : "vawdc",
      "region_code" : "vaw",
      "subdomain" : "ecf.vawd.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "03",
      "citation" : "Dist.VirginIslands",
      "code" : "vidce",
      "is_test" : false,
      "name" : "Virgin Islands District Court",
      "pcl_api_court_code" : "vidc",
      "region_code" : "vi",
      "subdomain" : "ecf.vid.uscourts.gov",
      "timezone" : "America/Virgin",
      "type" : "district"
   },
   {
      "circuit" : "02",
      "citation" : "Dist.Vt.",
      "code" : "vtdce",
      "is_test" : false,
      "name" : "Vermont District Court",
      "pcl_api_court_code" : "vtdc",
      "region_code" : "vt",
      "subdomain" : "ecf.vtd.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "09",
      "citation" : "Dist.E.D.Wash.",
      "code" : "waedce",
      "is_test" : false,
      "name" : "Washington Eastern District Court",
      "pcl_api_court_code" : "waedc",
      "region_code" : "wae",
      "subdomain" : "ecf.waed.uscourts.gov",
      "timezone" : "US/Pacific",
      "type" : "district"
   },
   {
      "circuit" : "09",
      "citation" : "Dist.W.D.Wash.",
      "code" : "wawdce",
      "is_test" : false,
      "name" : "Washington Western District Court",
      "pcl_api_court_code" : "wawdc",
      "region_code" : "waw",
      "subdomain" : "ecf.wawd.uscourts.gov",
      "timezone" : "US/Pacific",
      "type" : "district"
   },
   {
      "circuit" : "07",
      "citation" : "Dist.E.D.Wis.",
      "code" : "wiedce",
      "is_test" : false,
      "name" : "Wisconsin Eastern District Court",
      "pcl_api_court_code" : "wiedc",
      "region_code" : "wie",
      "subdomain" : "ecf.wied.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "district"
   },
   {
      "circuit" : "07",
      "citation" : "Dist.W.D.Wis",
      "code" : "wiwdce",
      "is_test" : false,
      "name" : "Wisconsin Western District Court",
      "pcl_api_court_code" : "wiwdc",
      "region_code" : "wiw",
      "subdomain" : "ecf.wiwd.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "district"
   },
   {
      "circuit" : "04",
      "citation" : "Dist.N.D.W.Va.",
      "code" : "wvndce",
      "is_test" : false,
      "name" : "West Virginia Northern District Court",
      "pcl_api_court_code" : "wvndc",
      "region_code" : "wvn",
      "subdomain" : "ecf.wvnd.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "04",
      "citation" : "Dist.S.D.W.Va.",
      "code" : "wvsdce",
      "is_test" : false,
      "name" : "West Virginia Southern District Court",
      "pcl_api_court_code" : "wvsdc",
      "region_code" : "wvs",
      "subdomain" : "ecf.wvsd.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "10",
      "citation" : "Dist.Wyo.",
      "code" : "wydce",
      "is_test" : false,
      "name" : "Wyoming District Court",
      "pcl_api_court_code" : "wydc",
      "region_code" : "wy",
      "subdomain" : "ecf.wyd.uscourts.gov",
      "timezone" : "US/Mountain",
      "type" : "district"
   },
   {
      "circuit" : null,
      "citation" : "INT",
      "code" : "citdce",
      "is_test" : false,
      "name" : "U.S. Court of International Trade",
      "pcl_api_court_code" : "citdc",
      "region_code" : "cit",
      "subdomain" : "ecf.cit.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "national"
   },
   {
      "circuit" : null,
      "citation" : "INT",
      "code" : "citdtest",
      "is_test" : true,
      "name" : "U.S. Court of International Trade (TEST Database)",
      "pcl_api_court_code" : null,
      "region_code" : "cit",
      "subdomain" : "ecf-test.cit.uscourts.gov",
      "timezone" : null,
      "type" : "national"
   },
   {
      "circuit" : null,
      "citation" : "Fed.Claim",
      "code" : "cofce",
      "is_test" : false,
      "name" : "U.S. Court of Federal Claims",
      "pcl_api_court_code" : "cofc",
      "region_code" : "cofc",
      "subdomain" : "ecf.cofc.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "national"
   },
   {
      "circuit" : null,
      "citation" : "JPML",
      "code" : "jpml",
      "is_test" : false,
      "name" : "Judicial Panel on Multidistrict Litigation",
      "pcl_api_court_code" : "jpmldc",
      "region_code" : "jpml",
      "subdomain" : "ecf.jpml.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "national"
   }
]



// WEBPACK FOOTER //
// ./src/data/courts.js